import styled from 'styled-components';

export const PricePlaceholderContainer = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const ManatIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    path {
      transform: scale(0.14, 0.145);
    }
  }
`;
